
import { defineComponent } from "vue";
import { agendaGuard } from "@/main/router/guards";

export default defineComponent({
  name: "Agenda",
  beforeRouteEnter: agendaGuard,
  beforeRouteUpdate: agendaGuard,
});
